import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import './summary.css';

const Summary = props => {
  const { email } = props;

  return (
    <React.Fragment>
      <div className="cierre-flujo">
        <FontAwesomeIcon icon={faCheckCircle} size="4x" color="#27ae60" />
        <p>
          <b>Un email ha sido enviado automáticamente</b> con el registro de la
          operación. Para mayor información de esta y otras operaciones,
          consulta en tu sitio privado Coopeuch o llámanos al 600 200 1200
        </p>
        <p>
          <b>Email de contacto</b>
          <br />
          {email}
        </p>

        <Link to="/listado" className="dap_btn-primary">
          Ir a Depósitos a Plazo
        </Link>
      </div>
    </React.Fragment>
  );
};

export default Summary;
